import '../host'

import { GatewayService } from '@graft/nuget-gc.webportals.gateways'

import { getSessionToken } from '@common/helpers'

const reportedInFlight = new Map<string, Promise<boolean>>()

export function isGatewayReported(projectId: string, gatewayName: string): Promise<boolean> {
  const normalizedProjectId = projectId.trim()
  const normalizedGatewayName = gatewayName.trim()

  if (!normalizedProjectId || !normalizedGatewayName) {
    return Promise.resolve(false)
  }

  const cacheKey = `${normalizedProjectId}:${normalizedGatewayName}`
  const inflight = reportedInFlight.get(cacheKey)
  if (inflight) {
    return inflight
  }

  const promise = (async () => {
    try {
      const token = await getSessionToken()
      return await GatewayService.isGatewayReported(token, normalizedProjectId, normalizedGatewayName)
    } catch (error) {
      console.error('Failed to check if gateway is reported:', error)
      return false
    } finally {
      reportedInFlight.delete(cacheKey)
    }
  })()

  reportedInFlight.set(cacheKey, promise)
  return promise
}
